<script lang="ts">
  import { candidates, currentMode, trips, activeCandidateId, enabledAmenityKeys } from '../lib/state';
  import { setActiveCandidate, removeCandidate } from '../lib/entities';
  import { overallScore, summarizeCandidate, scoreClass } from '../lib/scoring';

  /** Called when a row is chosen. Defaults to just selecting it; the sidebar
      overrides this to also drill into the candidate's breakdown view. */
  export let onSelect: (id: string) => void = setActiveCandidate;

  $: ranked = $candidates
    .map((c) => ({ c, summary: summarizeCandidate(c, $currentMode), overall: overallScore(c, $trips, $enabledAmenityKeys) }))
    .sort((a, b) => {
      const sa = a.overall?.total ?? -1;
      const sb = b.overall?.total ?? -1;
      if (sa !== sb) return sb - sa;
      return $candidates.indexOf(a.c) - $candidates.indexOf(b.c);
    });

  const firstLine = (addr: string) => (addr || '').split(',')[0];
</script>

{#if $candidates.length === 0}
  <div class="empty-state">No candidates yet. Add an address above, or drop one on the map.</div>
{:else}
  {#each ranked as entry, i (entry.c.id)}
    {@const c = entry.c}
    {@const score = entry.overall?.total}
    <div
      class="candidate"
      class:active={c.id === $activeCandidateId}
      role="button"
      tabindex="0"
      aria-pressed={c.id === $activeCandidateId}
      aria-label={`View detailed score for ${c.name}`}
      on:click={() => onSelect(c.id)}
      on:keydown={(e) => (e.key === 'Enter' || e.key === ' ') && onSelect(c.id)}
    >
      <span class="candidate-rank">{i + 1}</span>
      <div class="candidate-info">
        <div class="candidate-name">{c.name}</div>
        <div class="candidate-meta">
          {#if entry.summary}
            <span class={entry.summary.avgClass}>{entry.summary.avg} min avg</span> · {firstLine(c.address)}
          {:else}{firstLine(c.address) || 'computing…'}{/if}
        </div>
        <div class="candidate-detail-link">View detailed score <span aria-hidden="true">→</span></div>
      </div>
      <span class="candidate-score {score != null ? scoreClass(score) : 'muted'}">{score != null ? Math.round(score) : '–'}</span>
      <button class="candidate-remove" aria-label="Remove" on:click|stopPropagation={() => removeCandidate(c.id)}>×</button>
    </div>
  {/each}
{/if}
